module.exports = __webpack_public_path__ + "img/asesor.95a79e7a.png";